import CustomBreadcrumbs from 'src/legacy/components/custom-breadcrumbs';
import { useLocales } from 'src/legacy/locales';
import { useSelector } from 'src/legacy/redux/store';
import { PATH_DASHBOARD } from 'src/legacy/routes/paths';

import {
  defaultTabs,
  useClientDetailsNavigatorContext,
} from './ClientDetailsNavigatorContext';

export const Breadcrumbs = () => {
  const { translate } = useLocales();

  const { selectedClient } = useSelector((state) => state.client);

  const { currentTab } = useClientDetailsNavigatorContext();

  const displayName = `${selectedClient?.first_name || ''} ${
    selectedClient?.last_name || ''
  }`;
  const pageName =
    defaultTabs.find(({ value }) => value === currentTab)?.label || 'profile';

  return (
    <CustomBreadcrumbs
      heading={displayName}
      links={[
        { href: PATH_DASHBOARD.root, name: `${translate('dashboard')}` },
        { href: PATH_DASHBOARD.client.root, name: `${translate('clients')}` },
        { name: `${translate(pageName)}` },
      ]}
    />
  );
};
